export const COMPARE_MAX_PLAYERS = 5;
export const COMPARE_PAGE_TITLE = "Compare Players";
export const COMPARE_PAGE_SUBTITLE =
  "Pick two or more players — the chart updates automatically.";
export const COMPARE_CHART_HEIGHT = 420;

const CAREER_YEAR = {
  id: "careerYear",
  chipLabel: "Career years",
  axisName: "Career Year",
  mode: "careerYear",
};

const CALENDAR_YEAR = {
  id: "calendar",
  chipLabel: "Calendar years",
  axisName: "Year",
  mode: "season",
};

export function getCompareTimeframe(normalizeByCareer) {
  return normalizeByCareer ? CAREER_YEAR : CALENDAR_YEAR;
}

export function toComparePlayerSlots(playerIds = [], dataByIndex = []) {
  return playerIds.map((id, index) => ({
    id: id || null,
    data: id ? dataByIndex[index] || null : null,
  }));
}

export function assignIdToSlots(
  ids = [],
  playerId,
  maxSlots = COMPARE_MAX_PLAYERS
) {
  if (!playerId) return ids;
  if (ids.includes(playerId)) return ids;
  const emptyIndex = ids.findIndex((id) => !id);
  if (emptyIndex !== -1) {
    return ids.map((id, index) => (index === emptyIndex ? playerId : id));
  }
  if (ids.length < maxSlots) return [...ids, playerId];
  return ids;
}
